// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__sTIVX","delete":"styles_delete__36FBF","update":"styles_update__1voiU","add":"styles_add__j77dL"};